import styled, { css } from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';
import { FlexColumn } from '../../../../styled/common';
import { tagStyles } from '../../../ui/Typography/styles';
import { HeaderTitleWrapper } from '../../../ui/PageHeader/styled';

export const modalStyles = css`
  border-radius: 14px 14px 0 0;
  padding-bottom: env(safe-area-inset-bottom);
  height: max-content;
  align-self: end;

  @media (min-width: ${Breakpoints.tablet}px) {
    align-self: end;
    height: max-content;
    max-width: 100%;
    width: 100%;
    border-radius: 14px 14px 0 0;
  }
`;

export const headerStyles = css`
  @media (min-width: ${Breakpoints.tablet}px) {
    ${HeaderTitleWrapper} {
      text-align: center;
    }
  }
`;

export const PhonesList = styled(FlexColumn)`
  gap: 20px;
  padding: 20px 20px 40px;

  .contacts-item {
    height: 30px;

    .contacts-item__icon {
      width: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;

      svg path {
        fill: ${({ theme }) => theme.colors.text.secondary};
      }
    }

    .contacts-item__title {
      ${tagStyles.body_3};
    }
  }
`;
